import { render, staticRenderFns } from "./EventItemDetail_4.vue?vue&type=template&id=e13a1ec8"
import script from "./EventItemDetail_4.vue?vue&type=script&lang=js"
export * from "./EventItemDetail_4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports